module.exports = __webpack_public_path__ + "img/public/siteImages/messages.svg?816d6063";